<template>
  <div class="ship-popup">
    <div class="cesium-popup-header flex justify-between align-center">
      <span>航标信息</span>
      <ElButton circle size="small" @click="props.close">X</ElButton>
    </div>
    <table v-if="properties">
      <tbody>
        <tr v-for="item in tableData" :key="item.key">
          <td class="text-green-800">{{ item.key }}</td>
          <td>{{ item.value }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { ElButton } from 'element-plus'
import type { IMarckPointInfoType } from '../ToolsPannel/RightChildPannel/staticData'
import type { ImarkDetail } from '@/apiFzn/types'


const props = defineProps<{
  properties: ImarkDetail
  close(): void
}>()
const properties = computed(() => {
  return props.properties
})
const tableData = computed(() => {
  return [
    {
      key: '名称：',
      value: properties.value.name,
    },

    {
      key: '类型：',
      value: properties.value.structure,
    },
  ]
})
</script>
<style scoped>
.ship-popup {
  z-index: 998; /* 设置层级 */
}
</style>